import React, { Component } from "react";
import Modal from "react-modal";
import { connect } from "react-redux";
import { userActions } from "../../_actions";
import { userConstants } from "../../_constants";
import "../../assets/css/telCenter.css";
import loadingGif from "../../assets/images/loading.gif";
Modal.setAppElement("#root");

class TelCenter_ extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phones: [],
      isLoading: true,
      phoneModal: false,
      name: "",
      //   tels: [""],
      tel: "",
      isEditing: false,
      activeId: null,
    };
    this.globalStorage = this.props.globalStorage;
    this.config = {
      headers: {
        Authorization: JSON.parse(localStorage.getItem("tokenAdmin")),
      },
    };
  }

  componentDidMount = () => {
    this.getPhones();
  };

  getPhones = () => {
    this.props
      .dispatch(
        userActions.API(
          "get",
          `v1/sub_admin/hospital/phones`,
          null,
          true,
          false,
          JSON.parse(localStorage.getItem("tokenAdmin"))
        )
      )
      .then((res) => {
        this.setState({
          isLoading: false,
          phones: res.data.filter(
            (phone) =>
              phone.phone_type === "interval" && phone.operator === "not main"
          ),
        });
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  postPhones = () => {
    const { reset, getPhones } = this;
    const { name, tel } = this.state;
    const data = {
      title: name,
      number: tel,
      phone_type: "interval",
      operator: "not main",
    };

    this.props
      .dispatch(
        userActions.API(
          "post",
          `v1/sub_admin/hospital/phones`,
          data,
          true,
          false,
          JSON.parse(localStorage.getItem("tokenAdmin"))
        )
      )
      .then((res) => {
        getPhones();
        reset();
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  putPhones = () => {
    const { reset, getPhones } = this;
    const { name, tel, activeId } = this.state;
    const data = {
      id: activeId,
      title: name,
      number: tel,
      phone_type: "interval",
      operator: "not main",
    };

    this.props
      .dispatch(
        userActions.API(
          "put",
          `v1/sub_admin/hospital/phones`,
          data,
          true,
          false,
          JSON.parse(localStorage.getItem("tokenAdmin"))
        )
      )
      .then((res) => {
        getPhones();
        reset();
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  deletePhones = (id) => {
    const { getPhones } = this;

    this.props
      .dispatch(
        userActions.API(
          "delete",
          `v1/sub_admin/hospital/phones/${id}`,
          null,
          true,
          false,
          JSON.parse(localStorage.getItem("tokenAdmin"))
        )
      )
      .then((res) => {
        getPhones();
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  handleDelete = (id) => {
    this.props
      .dispatch(userActions.question("حذف", "آیا از حذف مطمئن هستید؟"))
      .then((r) => {
        if (r.value) {
          this.deletePhones(id);
        }
      });
  };

  reset = () => {
    this.setState({ phoneModal: false, name: "", tel: "", isEditing: false });
  };

  render() {
    const { dispatch, handleDelete, postPhones, reset, putPhones } = this;
    const { isLoading, phones, phoneModal, name, tel, isEditing } = this.state;
    return (
      <div className="container-fluid px-5 pb-5 mt-3 telCenter">
        <div className="row">
          <div className="col-lg-9 col-md-12 m-auto">
            <List onOpen={() => this.setState({ phoneModal: true })}>
              {isLoading ? (
                <Loading />
              ) : phones.length ? (
                phones.map((phone, i) => (
                  <ListItem
                    i={i}
                    key={i + 1}
                    phone={phone}
                    onEdit={() =>
                      this.setState({
                        phoneModal: true,
                        name: phone.title,
                        tel: phone.number,
                        activeId: phone.id,
                        isEditing: true,
                      })
                    }
                    onDelete={handleDelete}
                  />
                ))
              ) : (
                <EmptyListItem />
              )}
            </List>
            <Modal
              isOpen={phoneModal}
              contentLabel="Monitor Modal"
              portalClassName="full_screen_modal"
              className="telCenter"
            >
              <ModalPartners
                name={name}
                tel={tel}
                dispatch={dispatch}
                onClose={reset}
                isEditing={isEditing}
                onPost={() => (isEditing ? putPhones() : postPhones())}
                onName={(e) => this.setState({ name: e.target.value })}
                onTel={(e) => this.setState({ tel: e.target.value })}
              />
            </Modal>
          </div>
        </div>
      </div>
    );
  }
}

class ModalPartners extends Component {
  componentDidMount = () => {
    document.querySelector(".logout-btn").classList.add("hidden");
    document.querySelector(".logout-btn-bg").classList.add("hidden");
  };

  componentWillUnmount = () => {
    document.querySelector(".logout-btn").classList.remove("hidden");
    document.querySelector(".logout-btn-bg").classList.remove("hidden");
  };

  render() {
    const { name, tel, onClose, onPost, isEditing, onName, onTel } = this.props;

    return (
      <div className="modal--add-link telcenter_container">
        <div className="row col-lg-12 col-md-12 banner">
          <p>{isEditing ? "تغییر اپراتور" : "افزودن اپراتور"}</p>
          <button onClick={onClose}>&#10005;</button>
        </div>
        <div className="w-100 mt-4 px-4">
          <p className=" w-100 text-right my-2 mx-2 text_style d-flex py-2">
            نام اپراتور
          </p>
          <Input
            value={name}
            onChange={onName}
            placeholder="نام اپراتور را انتخاب کنید"
          />
        </div>
        <div className="w-100 mt-4 px-4">
          <p className=" w-100 text-right mb-2 mt-3 mx-2  text_style d-flex py-2">
            شماره اپراتور
          </p>
          <Input
            value={tel}
            // type="number"
            className="number-input tel_operator"
            onChange={onTel}
            placeholder="شماره اپراتور را انتخاب کنید"
          />
        </div>
        <div className="row col-lg-12 footer mt-5">
          <button
            onClick={() => {
              if (name.length === 0) {
                return userActions.failure("لطفا نام اپراتور را انتخاب کنید");
              } else if (tel.length === 0) {
                return userActions.failure("لطفا شماره اپراتور را انتخاب کنید");
              }
              onPost();
            }}
          >
            ثبت
          </button>
          <button className="ghost" onClick={onClose}>
            بازگشت
          </button>
        </div>
      </div>
    );
  }
}

class Input extends Component {
  render() {
    const { value, onChange, placeholder, style, type, className } = this.props;
    return (
      <input
        name="name"
        type={type ? type : "text"}
        className={`form-control ${className}`}
        aria-label="Full Name"
        style={style}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
      />
    );
  }
}

class EmptyListItem extends Component {
  render() {
    return (
      <li className="telCenter__list__item empty-list">
        <p className="telCenter__list__item__text empty-list__child">
          برای نمایش اطلاعات از دکمه های بالا استفاده نمایید
        </p>
      </li>
    );
  }
}

class List extends Component {
  render() {
    const { onOpen } = this.props;

    return (
      <div className="list-wrapper">
        <ul className="telCenter__list">
          <Banner />
          {this.props.children}
        </ul>
        <button
          className="btn btn-primary rounded-pill text-center mx-1 d-flex justify-content-center mx-auto mt-3"
          onClick={onOpen}
          style={{ minWidth: "150px" }}
        >
          <p className=" m-0 py-2">افزودن</p>
        </button>
      </div>
    );
  }
}

class Banner extends Component {
  render() {
    return (
      <li className="telCenter__list__banner" key="0">
        <div className="telCenter__list__banner__child">ردیف</div>
        <div className="telCenter__list__banner__child">شماره اپراتور</div>
        <div className="telCenter__list__banner__child">نام اپراتور</div>
        <div className="telCenter__list__banner__child">عملیـات</div>
      </li>
    );
  }
}

class ListItem extends Component {
  render() {
    // if (this.props.news === undefined) return null;

    const { i, phone, onDelete, onEdit } = this.props;
    const {
      id,
      hospital_id,
      title,
      number,
      phone_type,
      operator,
      created_at,
      updated_at,
    } = phone;

    return (
      <li className={`telCenter__list__item`}>
        <ListItemBtnContainer>
          <p className="telCenter__list__item__text">{i + 1}</p>
        </ListItemBtnContainer>
        <ListItemBtnContainer>
          <p className="telCenter__list__item__text">{number}</p>
        </ListItemBtnContainer>
        <ListItemBtnContainer>
          <p className="telCenter__list__item__text">{title}</p>
        </ListItemBtnContainer>
        <ListItemBtnContainer>
          <BtnRound className="edit-icon" onClick={onEdit} />
          <BtnRound className="delete-icon" onClick={() => onDelete(id)} />
        </ListItemBtnContainer>
      </li>
    );
  }
}

class BtnRound extends Component {
  render() {
    return (
      <button
        style={this.props.style}
        className={`btn-round ${this.props.className}`}
        onClick={this.props.onClick}
        data-tip={this.props.data_tip}
      ></button>
    );
  }
}

class ListItemBtnContainer extends Component {
  render() {
    return (
      <div className="telCenter__list__item__btn-container">
        {this.props.children}
        {/* <ReactTooltip type="dark" /> */}
      </div>
    );
  }
}

class Loading extends Component {
  render() {
    return (
      <li className="telCenter__list__item empty-list">
        <img src={loadingGif} style={{ width: "160px" }} />
      </li>
    );
  }
}

const TelCenter = connect((state) => ({
  globalStorage: state.globalStorage,
}))(TelCenter_);

export { TelCenter };
